import { useCallback, useRef, useState } from "react";
import { useParams } from 'react-router';
import { GetSpreedlyTokenViewModelQuery, GraphQLClient } from "../GraphQL.Default";
import { Spinner } from "../shared/Spinner";
import { Spreedly, SpreedlyResult } from "../shared/Spreedly";
import { useEffectAsync } from "../shared/useEffectAsync";
import { useGraphQL } from "../shared/useGraphQL";

export default function SpreedlyTokenSection() {
    const { creditCardKey } = useParams<{ creditCardKey: string }>();
    const graphQLClient = useGraphQL(GraphQLClient);
    const [model, setModel] = useState<GetSpreedlyTokenViewModelQuery['getSpreedlyTokenViewModel']>();
    const spreedlySubmitRef = useRef<HTMLButtonElement>(null);
    const [submitting, setSubmitting] = useState<boolean>();

    useEffectAsync(async () => {
        const result = await graphQLClient.getSpreedlyTokenViewModel(creditCardKey ?? "");
        setModel(result.data?.getSpreedlyTokenViewModel);
    }, [graphQLClient]);

    const submit = useCallback(async (token?: string | null) => {
        setSubmitting(true);
        window.curo?.postMessage('curo:spreedly-token', { token });
        setSubmitting(false);
    }, []);

    const spreedlyCallback = useCallback((result: SpreedlyResult) => {
        if (!result?.spreedlyError) {
            setModel(prev => prev != null ? { ...prev, spreedlyToken: result.spreedlyToken, spreedlyTokenAdded: true } : prev);
            submit(result.spreedlyToken);
        }
    }, [submit]);

    const handleSave = useCallback(async () => {
        if (!model?.spreedlyToken) {
            setTimeout(() => spreedlySubmitRef?.current?.click(), 100);
        }
        else {
            submit(model.spreedlyToken);
        }
    }, [model?.spreedlyToken, submit]);

    return (
        <div className="container">
            <Spreedly
                callback={spreedlyCallback}
                customerName={model?.customerName}
                fundingCardBin={model?.fundingCardBin}
                fundingCardMonth={model?.fundingCardMonth}
                fundingCardNumber={model?.fundingCardNumber}
                fundingCardYear={model?.fundingCardYear}
                submitRef={spreedlySubmitRef}
            />
            <div className="button-row mb-4">
                <button
                    id="btnSave"
                    className={`btn btn-success ${submitting ? 'disabled' : ''}`}
                    onClick={handleSave}
                    disabled={submitting}
                >
                    {submitting && <Spinner inline />}
                    Save
                </button>
            </div>
        </div>
    );
}